import type { ButtonHTMLAttributes, ReactNode } from "react";
import { tuple } from "../_util/type";

export const ButtonSize = tuple("xxs", "xs", "sm", "md", "lg");

export interface BaseButtonProps {
  // 设置按钮大小
  size?: typeof ButtonSize[number];
  // 幽灵属性，使按钮背景透明
  ghost?: boolean;
  // todo
  flat?: boolean;

  block?: boolean;

  // 按钮为主色
  primary?: boolean;
  // 设置按钮载入状态
  loading?: boolean;
  // 按钮失效状态
  disabled?: boolean;
  // Button 容器类名
  className?: string;

  classNameText?: string;
  // children
  children?: ReactNode;
}

export type ButtonProps = {
  onClick?: React.MouseEventHandler<HTMLElement>;
} & BaseButtonProps &
  Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type" | "onClick">;
